import React from "react";
import moment from "moment";
import { Spin } from "antd";
import { useTranslation } from "react-i18next";
import {
  FilePdfFilled,
  InfoCircleFilled,
  CheckCircleFilled,
  SyncOutlined,
  LoadingOutlined,
  DeleteFilled,
  ClockCircleOutlined,
} from "@ant-design/icons";
import Header from "./header";
import styles from "./style.module.scss";

const PlatformStatus = ({ status, t }) => {
  const statusKey = {
    Ready: "reports_page.status_ready",
    Pending: "reports_page.status_pending",
    Progress: "reports_page.status_progress",
    Processing: "reports_page.status_processing",
  }[status];
  const label = statusKey ? t(statusKey, status) : status;

  switch (status) {
    case "Ready":
      return (
        <>
          <CheckCircleFilled style={{ color: "lawngreen" }} />
          <span style={{ color: "lawngreen" }}>{label}</span>
        </>
      );
    case "Pending":
      return (
        <>
          <ClockCircleOutlined style={{ color: "#8C8C8C" }} />
          <span style={{ color: "#8C8C8C" }}>{label}</span>
        </>
      );
    case "Progress":
    case "Processing":
      return (
        <>
          <SyncOutlined spin style={{ color: "#F48A00" }} />
          <span style={{ color: "#F48A00" }}>{label}</span>
        </>
      );
    default:
      return (
        <>
          <InfoCircleFilled style={{ color: "red" }} />
          <span style={{ color: "red" }}>{label}</span>
        </>
      );
  }
};

const ReportItem = ({
  title,
  status,
  dashboardName,
  createdAt,
  dashboardId,
  csvLink,
  pdfLink,
  deleteReport,
  deleteInProgress,
  t,
}) => (
  <div className={styles.tableRow}>
    <p className={styles.nameRow}>{title}</p>
    <div className={styles.statusContainer}>
      <PlatformStatus status={status} t={t} />
    </div>
    <p className={styles.nameRow}>{dashboardName}</p>
    <p className={styles.createdAtRow}>{moment(createdAt).format("DD MMM YYYY")}</p>
    <div className={styles.downloadRow}>
      {pdfLink && (status === "Ready" || status === "InProgress") ? (
        <FilePdfFilled
          style={{ fontSize: "28px" }}
          onClick={() => window.open(pdfLink, "_blank")}
        />
      ) : null}
      {csvLink && (status === "Ready" || status === "InProgress") ? (
        <a href={csvLink} target="_blank" rel="noopener noreferrer">
          <img width="30" src="/assets/csvFile.png" alt="" />
        </a>
      ) : null}
    </div>
    <div className={styles.deleteRow}>
      {deleteInProgress === dashboardId ? (
        <LoadingOutlined spin style={{ fontSize: "28px" }} />
      ) : (
        <DeleteFilled
          style={{ fontSize: "28px" }}
          onClick={() => deleteReport(dashboardId)}
        />
      )}
    </div>
  </div>
);

const Representation = ({
  user,
  reports,
  getAllReports,
  deleteReport,
  loading,
  deleteInProgress,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <Header user={user} getAllReports={getAllReports} />
      <div className={styles.cardContent}>
        <FilePdfFilled style={{ fontSize: "48px" }} />
        <p className={styles.cardTitle}>
          {t(
            "reports_page.card_hint",
            "By generating reports from your dashboard you can save your data and insights",
          )}
        </p>
      </div>
      <div className={styles.tableHeader}>
        <p className={styles.nameRow}>{t("reports_page.col_name", "Name")}</p>
        <p className={styles.statusContainer}>{t("reports_page.col_status", "Status")}</p>
        <p className={styles.nameRow}>{t("reports_page.col_dashboard", "Dashboard Name")}</p>
        <p className={styles.createdAtRow}>{t("reports_page.col_created", "Created At")}</p>
        <p className={styles.downloadRow}>{t("reports_page.col_download", "Download")}</p>
        <p className={styles.deleteRow}>{t("reports_page.col_delete", "Delete")}</p>
      </div>
      <Spin spinning={loading} />
      {reports?.map((elem) => (
        <ReportItem
          key={elem.DashboardId || elem.Name}
          title={elem.Name}
          status={elem.Status}
          dashboardName={elem.DashboardName}
          createdAt={elem.CreationDate}
          pdfLink={elem.ReportLink}
          csvLink={elem.CSVLink}
          dashboardId={elem.DashboardId}
          deleteReport={deleteReport}
          deleteInProgress={deleteInProgress}
          t={t}
        />
      ))}
    </div>
  );
};

export default Representation;
